module.exports = __webpack_public_path__ + "img/welcome-gate.d7c24b96.png";